<template>
  <v-container
    fluid
    grid-list-lg
  >
    <v-layout
      column
      wrap
      class="pt-1"
    >
      <v-toolbar
        color="primary"
        dark
        tabs
      >
        <v-btn
          v-if="tipo != 1"
          icon
          @click="fechar()"
        >
          <v-icon>save_alt</v-icon>
        </v-btn>
        <v-text-field
          v-model="idOs"
          class="mx-3 pt-4 mt-5"
          label="Ordem de serviço"
          prepend-inner-icon="search"
          outlined
          :disabled="load"
          :error-messages="msg"
        />

        <v-btn
          outlined
          :loading="load"
          color="white"
          :disabled="idOs === null"
          @click="carregarDadosOS"
        >
          <v-icon left>
            search
          </v-icon> Buscar
        </v-btn>
        <template v-slot:extension>
          <v-tabs
            v-model="tabs"
            centered
            slider-color="orange"
          >
            <v-tab
              v-for="n in atendimentos"
              :key="n.dataChegada"
            >
              {{ formatDate(n.dataChegada) }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <div
        v-show="nomePaciente"
        class="my-2"
      >
        Paciente: <strong>{{ nomePaciente }}</strong>
      </div>
      
      <v-card v-if="atendimentos.length > 0">
        <table>
          <tr id="thExame">
            <th>Recepcionista</th>
            <th>Chegada</th>
            <th>Inicio do atendimento</th>
            <th>Fim do atendimento</th>
            <th>Código</th>
            <th>Prioridade</th>
          </tr>
          <tr>
            <td>{{ atendimentos[tabs].nomeRecepcionista }}</td>
            <td>{{ formatDate(atendimentos[tabs].dataChegada) }}</td>
            <td>{{ formatDate(atendimentos[tabs].dataInicioAtendimento) }}</td>
            <td>{{ formatDate(atendimentos[tabs].dataFinalAtendimento) }}</td>
            <td>{{ atendimentos[tabs].codigo }}</td>
            <td>{{ formatPrioridade(atendimentos[tabs].prioridade) }}</td>
          </tr>
        </table>
        <table>
          <tr id="thAtendimento">
            <th>Nome exame</th>
            <th>Status</th>
            <th>Chegada</th>
            <th>Saída</th>
            <th>Médico/Técnico</th>
            <td>Opções</td>
          </tr>
          <tr
            v-for="exame in atendimentos[tabs].exames"
            :key="exame.idAtendimento"
          >
            <td>{{ exame.nomeExame }}</td>
            <td>{{ formatStatus(exame.status) }}</td>
            <td>{{ formatDate(exame.dataChegadaConsulta) }}</td>
            <td>{{ formatDate(exame.dataSaida) }}</td>
            <td>{{ exame.nomeMedico }}</td>
            <td>
              <v-btn
                text
                color="triadeE"
                this-id-exame="idExame"
                @click="alterarMedico(exame.idExame, exame.idAtendimento, exame.idConsulta)"
              >
                <v-icon left>
                  mdi-pencil
                </v-icon>
                Alterar médico
              </v-btn>
            </td>
          </tr>
        </table>
      </v-card>
      
      <!-- <v-alert
        :value="msg"
        color="error"
        icon="warning"
        outlined
      >
        {{ msg }}
      </v-alert> -->
      <v-dialog
        v-model="dialog"
        width="500"
      >
        <v-card>
          <v-card-title class="headline grey lighten-2">
            Alterar preferência médica
          </v-card-title>
          <div class="ma-2">
            <v-select
              v-model="unidade"
              :loading="loadMedicos"
              :items="medicosExame"
              label="Unidades"
              item-text="key"
              return-object
            />
            <v-select 
              v-model="medico"
              :disabled="!unidade"
              return-object
              label="Médico"
              item-text="nome"
              :items="unidade.values"
            />
          </div>
          <v-divider />
          <v-alert
            v-show="msgErro"
            border="top"
            dismissible
            outlined
            class="ma-2"
            type="warning"
          >
            Verifique se esse atendimento já foi encerrado e tende novamente. 
          </v-alert>
          <v-alert
            v-show="msgSuccess"
            border="top"
            class="ma-2"
            type="success"
          >
            Médico alterado com sucesso! 
          </v-alert>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              text
              :loading="loadAlterar"
              @click="atualizarMedico"
            >
              Atualizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>

import service from '../../services/administradorUnidade.service'
import recepcionistaService from '../../services/recepcionista.service'
import moment from 'moment'

export default {
  name: 'InfoPaciente',

  props: {
    tipo: Number
  },

  data: (vm) => ({
    load: false,
    tabs: 1,
    idOs: null,
    nomePaciente: '',
    dialog: false,
    load: false,
    msg: '',
    loadMedicos: false,
    atendimentos: [],
    medicosExame: [],
    msgSuccess: false,
    unidade: '',
    loadAlterar: false,
    msgErro: false,
    medico: '',
    idExame: '',
    idAtendimento: '',
    idConsulta: '',
    idUnidade: ''
  }),
  computed: {

  },

  watch: {
    steps (val) {
      if (this.e1 > val) {
        this.e1 = val
      }
    },
    idOs (val) {
      this.msg = ''
    },
    msgSuccess () {
      setTimeout(() => {
        this.dialog = false
      }, 3000)
    }
  },
  mounted () {

  },

  created () {
    console.log('created...')
  },

  methods: {
    fechar () {
      this.$emit('fechar')
    },
    formatPrioridade (p) {
      var codigo = ''
      switch (p) {
        case 0:
          codigo = 'Convencional'
          break
        case 1:
          codigo = 'Idoso, Gestante, ...'
          break
        case 2:
          codigo = 'Prioridade de serviço'
          break
        case 3:
          codigo = '(Idoso, Gestante, ...) e Serviço'
          break
        case 4:
          codigo = 'Emergência'
          break
      }
      return codigo
    },
    formatStatus (s) {
      var status = ''
      switch (parseInt(s)) {
        case 0:
          status = 'Aguardando conclusão de outros exames'
          break
        case 1:
          status = 'Pronto para o atendimento'
          break
        case 2:
          status = 'Concluido'
          break
      }
      return status
    },
    formatDate (date) {
      if (date == null || date === '') {
        return ''
      } else {
        return moment(date).format('DD/MM/YYYY hh:mm:ss')
      }
    },
    carregarDadosOS () {
      this.nomePaciente = ''
      this.atendimentos = []
      this.tabs = 1
      this.load = true
      if (this.tipo == 1) {
        service.administradorUnidade.retornarInfoOS(this.idOs).then(r => {
          if (r.status === 200) {
            if (r.data) {
              this.nomePaciente = r.data.nomePaciente
              this.atendimentos = r.data.atendimentos
              console.log(atendimentos);
            } else {
              this.msg = 'Os não encontrada'
            }
          }
        }).finally(() => {
          this.load = false
        })
      } else {
        recepcionistaService.recepcionista.retornarInfoOS(this.idOs).then(r => {
          if (r.status === 200) {
            if (r.data) {
              this.nomePaciente = r.data.nomePaciente
              this.atendimentos = r.data.atendimentos
            } else {
              this.msg = 'Os não encontrada'
            }
          }
        }).finally(() => {
          this.load = false
        })
      }
    },
    // retornarUnidadesGrupo () {
    //   this.loadUnidade = true
    //   recepcionistaService.recepcionista.retornarUnidadesGrupo().then(r => {
    //     if (r.status == 200) {
    //       this.unidades = r.data
    //     }
    //   }).finally(() => {
    //     this.loadUnidade = false
    //   })
    // },
    retornarMedicos () {
      this.loadMedicos = true
      if (this.tipo == 1) {
         service.administradorUnidade.retornarMedicosExame(this.idExame).then(r => {
          if (r.status == 200) {
            this.medicosExame = this.groupBy(r.data, 'nomeUnidade')
          }
        }).finally(() => {
          this.loadMedicos = false  
        })
      } else {
        recepcionistaService.recepcionista.retornarMedicosExame(this.idExame).then(r => {
          if (r.status == 200) {
            this.medicosExame = this.groupBy(r.data, 'nomeUnidade')
          }
        }).finally(() => {
          this.loadMedicos = false  
        })
      }
    },
    alterarMedico (idExame, idAtendimento, idConsulta) {
      this.idExame = idExame
      this.idAtendimento = idAtendimento
      this.idConsulta = idConsulta
      this.dialog = !this.dialog
      this.retornarMedicos()
    },
    onInput (val) {
      this.steps = parseInt(val)
    },
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    groupBy (lista, coluna) {
        var colunas = {};
        var resultado = [];
        lista.forEach(function (item) {
          var reg = {};
          colunas[item[coluna]] = colunas[item[coluna]] || [];
          for (var i in item) 
            if (i != coluna) 
              reg[i] = item[i]; 
            colunas[item[coluna]].push(reg);
        });
        for (var i in colunas) {
          resultado.push({key: i, values: colunas[i]});
        }
        return resultado;
      },
     atualizarMedico () {
       this.loadAlterar = true
      recepcionistaService.recepcionista.alterarMedicoConsulta(this.idAtendimento, this.idConsulta, this.medico.idMedico).then(r => {
        if (r.data) {
          if (r.data) {
          this.msgSuccess = true
          } else {
            this.msgErro = true
          }
        }
      }).finally(() => {
        this.loadAlterar = false
      })
    }
  }
}
</script>

<style scoped>
  table {
  border-collapse: collapse;
  width: 100%;
}

th, td {
  text-align: left;
  padding: 8px;
}

tr:nth-child(even){background-color: #f2f2f2}

#thAtendimento {
  background-color: #00897b;
  color: white;
}

#thExame {
  background-color: #005b4f;
  color: white;
}

</style>
